
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3ebd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3ebd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("04iQo", function(module, exports) {

$parcel$export(module.exports, "darkMode", () => $00cefde3a1e875c9$export$808aaf1b460dc9af);
// //     // On page load or when changing themes, best to add inline in `head` to avoid FOUC
//     export const darkMode= function(){
//         if (localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
//             document.documentElement.classList.add('dark');
//         } else {
//             document.documentElement.classList.remove('dark')
//         }
//         let themeToggleDarkIcon = document.querySelector('.theme-toggle-dark-icon');
//         let themeToggleLightIcon = document.querySelector('.theme-toggle-light-icon');
// // Change the icons inside the button based on previous settings
// if (localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
//     themeToggleLightIcon.classList.remove('hidden');
// } else {
//     themeToggleDarkIcon.classList.remove('hidden');
// }
// let themeToggleBtn = document.getElementById('theme-toggle');
// themeToggleBtn.addEventListener('click', function() {
//     // toggle icons inside button
//     themeToggleDarkIcon.classList.toggle('hidden');
//     themeToggleLightIcon.classList.toggle('hidden');
//     // if set via local storage previously
//     if (localStorage.getItem('color-theme')) {
//         if (localStorage.getItem('color-theme') === 'light') {
//             document.documentElement.classList.add('dark');
//             localStorage.setItem('color-theme', 'dark');
//         } else {
//             document.documentElement.classList.remove('dark');
//             localStorage.setItem('color-theme', 'light');
//         }
//     // if NOT set via local storage previously
//     } else {
//         if (document.documentElement.classList.contains('dark')) {
//             document.documentElement.classList.remove('dark');
//             localStorage.setItem('color-theme', 'light');
//         } else {
//             document.documentElement.classList.add('dark');
//             localStorage.setItem('color-theme', 'dark');
//         }
//     }
// });
//     }
const $00cefde3a1e875c9$export$808aaf1b460dc9af = function() {
    if (localStorage.getItem("color-theme") === "light" || !("color-theme" in localStorage) && !window.matchMedia("(prefers-color-scheme: dark)").matches) document.documentElement.classList.remove("dark");
    else document.documentElement.classList.add("dark");
    let themeToggleDarkIcon = document.querySelector(".theme-toggle-dark-icon");
    let themeToggleLightIcon = document.querySelector(".theme-toggle-light-icon");
    // Change the icons inside the button based on previous settings
    if (localStorage.getItem("color-theme") === "light" || !("color-theme" in localStorage) && !window.matchMedia("(prefers-color-scheme: dark)").matches) themeToggleDarkIcon.classList.remove("hidden");
    else themeToggleLightIcon.classList.remove("hidden");
    let themeToggleBtn = document.getElementById("theme-toggle");
    themeToggleBtn.addEventListener("click", function() {
        // toggle icons inside button
        themeToggleDarkIcon.classList.toggle("hidden");
        themeToggleLightIcon.classList.toggle("hidden");
        // if set via local storage previously
        if (localStorage.getItem("color-theme")) {
            if (localStorage.getItem("color-theme") === "light") {
                document.documentElement.classList.add("dark");
                localStorage.setItem("color-theme", "dark");
            } else {
                document.documentElement.classList.remove("dark");
                localStorage.setItem("color-theme", "light");
            }
        } else if (document.documentElement.classList.contains("dark")) {
            document.documentElement.classList.remove("dark");
            localStorage.setItem("color-theme", "light");
        } else {
            document.documentElement.classList.add("dark");
            localStorage.setItem("color-theme", "dark");
        }
    });
};

});


var $04iQo = parcelRequire("04iQo");
document.addEventListener("DOMContentLoaded", function() {
    (0, $04iQo.darkMode)();
});
//language switch
const $120c55186a84fe3d$var$lanDiv = document.querySelector(".switchLangDiv");
$120c55186a84fe3d$var$lanDiv.addEventListener("click", (e)=>{
    const target = e.target;
    //1- toggle the language list when click
    if (target.closest(".currentLang")) {
        console.log("hi");
        const languageOptionsEl = target.closest(".currentLang").nextElementSibling;
        console.log(languageOptionsEl);
        if (languageOptionsEl.classList.contains("hidden")) {
            languageOptionsEl.classList.remove("hidden");
            languageOptionsEl.classList.add("flex");
        } else {
            languageOptionsEl.classList.add("hidden");
            languageOptionsEl.classList.remove("flex");
        }
    }
});


//# sourceMappingURL=privacy&terms-de.820664e9.js.map
